<template>
    <nav aria-label="paginacao" v-show="totalPages > 1">
        <ul class="pagination justify-content-center pt-3 justify-content-md-end align-items-center">
            <li class="page-item page-item-prev">
                <nuxt-link :to="{ query: queryPage(prevPage)}" class="page-link page-link-prev nav" :class="{'disabled': isInFirstPage}" title="Anterior">
                    <svg class="pagination-button" width="16px" height="16px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M14 5l-7 7 7 7"/>
                    </svg>
                </nuxt-link>
            </li>
            <li class="page-item page-item-number" v-for="page in pages" :key="page.name" :class="{ 'actived': isPageActive(page.name) }">
                <nuxt-link :to="{ query: queryPage(page.name)}" class="page-link page-link-number" @click.prevent="onClickPage(page.name)" :class="{ 'actived': isPageActive(page.name) }">{{ page.name }}</nuxt-link>
            </li>
            <li class="page-item page-item-next">
                <nuxt-link :to="{ query: queryPage(nextPage)}" class="page-link page-link-next nav" :class="{'disabled': isInLastPage}" title="Próximo">
                    <svg class="pagination-button" width="16px" height="16px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M10 5l7 7-7 7"/>
                    </svg>
                </nuxt-link>
            </li>
        </ul>
    </nav>
</template>

<script>
export default {
    props: {
        maxVisibleButtons: {
            type: Number,
            required: false,
            default: 4
        },
        // totalPages: {
        //     type: Number,
        //     // required: true
        // },
        total: {
            // type: Number,
            required: true
        },
        perPage: {
            required: true
        },
        // currentPage: {
        //     // type: Number,
        //     required: true
        // },
        page_query: {
            type: String,
            default: 'page'
        }
    },
    computed: {
        currentPage() {
            if (this.$route.query.page > 1) {
                return this.$route.query.page
            }
            return 1
        },
        totalPages() {
            let total = Math.ceil(this.total / this.perPage);
            if (total) {
                return total;
            }
            return 1;
        },
        startPage() {
            if (this.currentPage === 1) {
                return 1;
            }

            if (this.currentPage === this.totalPages) {
                return this.totalPages - this.maxVisibleButtons + 1;
            }

            return this.currentPage - 1;
        },
        endPage() {
            return Math.min(this.startPage + this.maxVisibleButtons - 1, this.totalPages);
        },
        pages() {
            const range = [];
            if (this.totalPages > 1) {
                let i = this.startPage;
                if (i < 1) {
                    i = 1;
                }
                for (i; i <= this.endPage; i += 1) {
                    range.push({
                    name: i,
                    isDisabled: i === this.currentPage
                    });
                }
            } else {
                range.push({
                    name: 1,
                    isDisabled: true
                });
            }
            return range;
        },
        isInFirstPage() {
            return this.currentPage == 1;
        },
        isInLastPage() {
            return this.currentPage == this.totalPages;
        },
        prevPage() {
            if (this.currentPage > 1) {
                return parseInt(this.currentPage) - 1
            }
            return 1
        },
        nextPage(page) {
            if (this.currentPage < this.totalPages) {
                return parseInt(this.currentPage) + 1
            }
            return this.totalPages
        }
    },
    methods: {
        onClickFirstPage() {
            this.$emit('pagechanged', 1);
        },
        onClickPreviousPage() {
            if (this.currentPage > 1) {
                this.$emit('pagechanged', this.currentPage - 1);
            }
        },
        onClickPage(page) {
            if (page <= this.totalPages) {
                this.$emit('pagechanged', page);
            }
        },
        onClickNextPage() {
            if (this.currentPage < this.totalPages) {
                this.$emit('pagechanged', parseInt(this.currentPage) + 1);
            }
        },
        onClickLastPage() {
            this.$emit('pagechanged', this.totalPages);
        },
        isPageActive(page) {
            if (parseInt(this.currentPage) === page)
                return true;
        },
        queryPage(page) {
            let query = Object.assign({}, this.$route.query);
            query[this.page_query] = page
            return query
        }
    },
    watch: {
        currentPage(newval, oldval) {
            if (newval !== oldval) {
                this.$emit('pagechanged', newval);
            }
        }
    }
};
</script>
